import { Core } from "@faire/design-tokens";
import { Column, Grid, Row } from "@faire/web--source/slate/Layout";
import { LoadingSkeleton } from "@faire/web--source/slate/LoadingSkeleton";
import { Spacer, getSpacing } from "@faire/web--source/slate/spacing";
import { useViewport } from "@faire/web--source/ui/hooks/useViewport";
import React from "react";
import styled from "styled-components";

import { BRAND_ORDERS_PAGE_SIZE } from "../consts";
import { useOrderItemCardGrid } from "../hooks/useOrderItemCardGrid";

export const GridOrderItemCardsLoadingSkeleton: React.FC = () => {
  const { gap, itemsPerRow } = useOrderItemCardGrid();
  const { isMobile } = useViewport();
  return (
    <Grid
      gap={gap}
      columns={itemsPerRow}
      style={{ width: "100%" }}
      columnTemplate={(columns: number) =>
        isMobile
          ? `repeat(${columns}, minmax(150px, 1fr))`
          : `repeat(${columns}, 1fr)`
      }
    >
      {Array.from({ length: BRAND_ORDERS_PAGE_SIZE }).map((_, index) => (
        <OrderItemCardLoadingSkeleton key={index} />
      ))}
    </Grid>
  );
};

const OrderItemCardLoadingSkeleton: React.FC = () => {
  return (
    <OrderItemCardWrapper>
      <LoadingSkeleton height="100px" width="100px" />
      <Spacer width="3x" />
      <Column>
        <LoadingSkeleton height="25px" width="100px" />
        <Spacer height="1x" />
        <LoadingSkeleton height="12px" width="200px" />
        <Spacer height="1x" />
        <LoadingSkeleton height="12px" width="200px" />
        <Spacer height="1x" />
        <LoadingSkeleton height="12px" width="200px" />
      </Column>
    </OrderItemCardWrapper>
  );
};

const OrderItemCardWrapper = styled(Row).attrs({ align: "center" })`
  border: 1px solid ${Core.border.muted};
  border-radius: 4px;
  padding: ${getSpacing("2x")};
  min-height: 120px;
  min-width: 326px;
  height: auto;
  width: 100%;
  cursor: pointer;
`;
